export enum PermissionForStudents {
	QUIZ_RESULT = 'quiz:result',
	QUIZ_VIEW = 'quiz:view',
	QUIZ_TAKE = 'quiz:take',
	QUIZ_CREATE = 'quiz:create',
	QUIZ_UPDATE = 'quiz:update',
	QUIZ_DELETE = 'quiz:delete',
	QUIZ_PUBLISH = 'quiz:publish',
	QUIZ_GRADE = 'quiz:grade',
	QUIZ_MANAGE_LIST = 'quiz:manage:list',

	INTERVIEW_TAKE = 'interview:take',
	INTERVIEW_VIEW = 'interview:view',
	INTERVIEW_VIEW_RESULTS = 'interview:view_results',
	INTERVIEW_DELETE = 'interview:delete',
	INTERVIEW_CREATE = 'interview:create',
	INTERVIEW_UPDATE = 'interview:update',
	
	PRACTICE_INTERVIEW_TAKE = 'practice_interview:take',
	PRACTICE_INTERVIEW_VIEW = 'practice_interview:view',
	PRACTICE_INTERVIEW_VIEW_RESULTS = 'practice_interview:view_results',
	PRACTICE_INTERVIEW_DELETE = 'practice_interview:delete',
	PRACTICE_INTERVIEW_CREATE = 'practice_interview:create',
	PRACTICE_INTERVIEW_UPDATE = 'practice_interview:update',
	PRACTICE_INTERVIEW_MANAGE_LIST = 'practice_interview:manage:list',

	USER_PROFILE_VIEW = 'user:profile_view',
	USER_UPDATE = 'user:update',
	USER_READ = 'user:read',

	CLASSROOM_READ = 'classroom:read',
	CLASSROOM_JOIN = 'classroom:join',

	PLACEMENT_TAKE = 'placement:take',
	PLACEMENT_VIEW = 'placement:view',
	PLACEMENT_VIEW_RESULTS = 'placement:view_results',
	PLACEMENT_CREATE = 'placement:create',

	PAYMENTS_CREATE = 'payment:create',
	PAYMENTS_VIEW = 'payments:view',
	PAYMENTS_TRANSACTIONS = 'payments:transactions',
	PAYMENTS_MANAGE_LIST = 'payment:manage:list',
	PRODUCT_PACKAGES = 'product:packages',

	NOTIFICATION_VIEW = 'notification:view',
	NOTIFICATION_MARK_AS_READ = 'notification:mark_as_read',

	COURSE_VIEW = 'course:view',
	COURSE_ENROLL = 'course:enroll',
	COURSE_CREATE = 'course:create',
	COURSE_UPDATE = 'course:update',
	COURSE_DELETE = 'course:delete',
	COURSE_PUBLISH = 'course:publish',
	COURSE_MANAGE_LIST = 'course:manage:list',

	MENTOR_VIEW = 'mentor:view',
	MENTOR_BOOK = 'mentor:book',
	MENTOR_VIEW_BOOKINGS = 'mentor:view_bookings',
	MENTOR_CANCELLATION = 'mentor:cancellation',
	MENTOR_REFUND = 'mentor:refund',
	MENTOR_SESSIONS = 'mentor:sessions',
	MENTOR_CREATE = 'mentor:create',

	DASHBOARD_STUDENT = 'dashboard:student',
	DASHBOARD_ADMIN = 'dashboard:superadmin',
	DASHBOARD_MENTOR = 'dashboard:mentor',

	HIGHER_STUDIES_ACCESS = 'higher_studies:access',

	USAGE_VIEW = 'usage:view',
	INVOICE_DOWNLOAD = 'invoice:download',

	USER_MANAGEMENT_VIEW = 'user_management:view',
	USER_MANAGEMENT_VIEW_ENROLLMENTS = 'user_management:view_enrollments',
	USER_MANAGEMENT_VIEW_QUIZZES = 'user_management:view_quizzes',

	ROADMAP_CREATE = 'roadmap:create',
	ROADMAP_UPDATE = 'roadmap:update',
	ROADMAP_DELETE = 'roadmap:delete',
	ROADMAP_VIEW = 'roadmap:view',
	ROADMAP_TRACK = 'roadmap:track',

	RESUME_SUGGEST = 'resume:suggest',
	RESUME_UPDATE = 'resume:update',
	RESUME_READ = 'resume:read',
	RESUME_DELETE = 'resume:delete',
	RESUME_EXPORT = 'resume:export',
	RESUME_CREATE = 'resume:create',
	RESUME_ANALYZE = 'resume:analyze',

	COMPANY_MANAGE = 'company:manage',

	COLLEGE_PORTAL_READ = 'college_portal:read',
	COLLEGE_PORTAL_UPDATE = 'college_portal:update',
	COLLEGE_PORTAL_MANAGE = 'college_portal:manage',

	JOB_VIEW = 'job:view',
	JOB_APPLY = 'job:apply',
	JOB_READ = 'job:read',
	JOB_CREATE = 'job:create',
	JOB_UPDATE = 'job:update',
	JOB_MANAGE = 'job:manage',

	PROCTORING_CREATE = 'proctoring:create',
	PROCTORING_UPDATE = 'proctoring:update',
	PROCTORING_READ = 'proctoring:read',
	PROCTORING_DELETE = 'proctoring:delete',

	PROCTORING_CONFIG = 'proctoring:config',
	PROCTORING_DASHBOARD = 'proctoring:dashboard',
	PROCTORING_RULESET = 'proctoring:ruleset',
	PROCTORING_ASSESSMENT = 'proctoring:assessments',

	CANDIDATE_VIEW_FRESHER = 'candidate:view_fresher',
	CANDIDATE_VIEW_EXPERIENCED = 'candidate:view_experienced',
	CANDIDATE_VIEW_EDUCATOR = 'candidate:view_educator',

	MOCK_TEST = 'mock:test'
}